/**
 * Persist create-booking flow across full page refresh (same idea as EditBookingPage session keys).
 * Clear on Cancel to list, successful booking, or when leaving the wizard back to customer step.
 */

export const CREATE_BOOKING_SK = {
  customerName: "createBooking_customerName",
  phone: "createBooking_phone",
  email: "createBooking_email",
  basicUser: "createBooking_basicUser",
  bookingFlowOpen: "createBooking_bookingFlowOpen",
  step: "createBooking_step",
  hubId: "createBooking_hubId",
  modelId: "createBooking_modelId",
  vehicleId: "createBooking_vehicleId",
  planId: "createBooking_planId",
  wizardCustomerUserId: "createBooking_wizardCustomerUserId",
} as const;

export function clearCreateBookingWizardSession(): void {
  [
    CREATE_BOOKING_SK.step,
    CREATE_BOOKING_SK.hubId,
    CREATE_BOOKING_SK.modelId,
    CREATE_BOOKING_SK.vehicleId,
    CREATE_BOOKING_SK.planId,
    CREATE_BOOKING_SK.wizardCustomerUserId,
  ].forEach((k) => {
    try {
      sessionStorage.removeItem(k);
    } catch {
      // ignore
    }
  });
}

export function clearCreateBookingDraft(): void {
  Object.values(CREATE_BOOKING_SK).forEach((k) => {
    try {
      sessionStorage.removeItem(k);
    } catch {
      // ignore
    }
  });
}
